module.exports = __webpack_public_path__ + "img/s3-5.d4bea87a.jpg";